<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_5"><span class="silkenbook">contents</span></a></p><a id="page_5">
</a><ol><a id="page_5">
</a><li><a id="page_5"></a><a href="#/introduction"><span class="s2">Introduction</span></a></li>
<li><a href="#/chapter01"><span class="s1">STEP 1</span><br/><span class="s2">Seek INSPIRATION</span></a></li>
<li><span href="#/chapter02" title="Link target outside of Sample"><span class="s1">STEP 2</span><br/><span class="s2">Find your PERSONAL STYLE</span></span></li>
<li><span href="#/chapter03" title="Link target outside of Sample"><span class="s1">STEP 3</span><br/><span class="s2">IDENTIFY your project</span></span></li>
<li><span href="#/chapter04" title="Link target outside of Sample"><span class="s1">STEP 4</span><br/><span class="s2">PREP your space</span></span></li>
<li><span href="#/chapter05" title="Link target outside of Sample"><span class="s1">STEP 5</span><br/><span class="s2">DRAW UP your space</span></span></li>
<li><span href="#/chapter06" title="Link target outside of Sample"><span class="s1">STEP 6</span><br/><span class="s2">Translate your IDEAS</span></span></li>
<li><span href="#/chapter07" title="Link target outside of Sample"><span class="s1">STEP 7</span><br/><span class="s2">FINALIZE your scheme</span></span></li>
<li><span href="#/chapter08" title="Link target outside of Sample"><span class="s1">STEP 8</span><br/><span class="s2">Happy DECORATING</span></span></li>
<li><span href="#/final" title="Link target outside of Sample"><span class="s2">Final Words</span></span></li>
<li><span href="#/directory" title="Link target outside of Sample"><span class="s2">Directory</span></span></li>
<li><span href="#/photocredits" title="Link target outside of Sample"><span class="s2">Photo Credits</span></span></li>
<li><span href="#/acknowledgments" title="Link target outside of Sample"><span class="s2">Acknowledgments</span></span></li>
<li><span href="#/author" title="Link target outside of Sample"><span class="s2">About the Author</span></span></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6706a41d